// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"a138198b","790":"7f4628fd"}[chunkId] + ".chunk.js";
};